import LuissState from "../../luiss_state";
import {connect} from "react-redux";
import {ACTIONS} from "../../actions";
import LuissNavbar from "../../../containers/main_menu/navbar_global/navbar_global";

const mapStateToProps = (state: LuissState | any) => ({
    path: state.router.location.pathname,
    language: state.app.language,
    baseColor: state.app.menuColor,
    breadcrumb: state.app.breadcrumb
});

const mapDispatchToProps = (dispatch: any) => ({
    changeLanguage: (language: string) => {
        dispatch(ACTIONS.changeLanguage(language))
    }
});


export default connect(mapStateToProps, mapDispatchToProps)(LuissNavbar);
